import moment from 'moment';

import injected from '../injected';

var comment = function comment(text) {
  return {
    id: null,
    from: {
      userId: injected.user.id,
      picture: injected.user.picture,
      displayName: injected.user.displayName
    },
    creationTime: moment().format(),
    richText: text
  };
};

export default comment;
//# sourceMappingURL=comment.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/models/comment.js
// module id = 631
// module chunks = 0